import styled from 'styled-components'

const injectColor = ({isOrderActive}) => (isOrderActive ? '#1E7BE1' : '#6c757d')

export const ActionIcon = styled.i`
  color: #1e7be1;
  cursor: pointer;
`

export const OrderContainer = styled.div`
  color: ${injectColor};
  cursor: pointer;
  text-transform: uppercase;
  i {
    color: ${injectColor};
  }
  span {
    margin-right: 5px;
  }
`
